import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { StyledButton } from './PrimaryButton.styles';

const PrimaryButton = ({
  children,
  disabled,
  loading,
  color = 'primary',
  ...props
}) => {
  const buttonProps = {
    variant: 'contained',
    size: 'medium',
    color,
    disabled: disabled || loading,
    ...(props.to && {
      component: Link,
    }),
    ...props,
  };

  return (
    <StyledButton {...buttonProps}>
      {loading ? (
        <>
          <CircularProgress size={16} color="inherit" />
          {children}
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.string,
  to: PropTypes.any,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

export default memo(PrimaryButton);
